import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,numberFormat } from '../../../../utils/utils';
import { Box } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    height: 72,
    padding: "16px 32px",
    display: 'flex',
    alignItems: 'center',
    backgroundColor:'#fff',
    justifyContent:'center',
    borderRadius: 8,
    border: 'solid 1px #ddd',
    boxShadow:'none'
  },
  icon:{
    fontSize:52,
    color:'#000'
  },
  label:{
    color:'#636872',
    fontSize:12,
    marginBottom:4
  },
  value:{
    fontWeight:600,
    color:'#0b1323',
    fontSize:14,
    textAlign:'center'
  }
}));
const JourneyTripLRCard = (props) => {
  const {number} = props;
  const classes = useStyles();
  let history = useHistory();
  return (
    <>
      <Paper component='div' className={classes.card} >
          <div>
            <Typography className={classes.label}>LR Number</Typography>
            <Typography className={classes.value}>{number?number:'----'}</Typography>
          </div>
      </Paper>
    </>
  );
}
export default JourneyTripLRCard;